export const NETFLIX_SELECTION_MODAL_TEST_ID = {
    MODAL: 'netflix-selection-modal',
    NETFLIX_STANDARD_BUTTON: 'netflix-selection-modal-standard-button',
    NETFLIX_PREMIUM_BUTTON: 'netflix-selection-modal-premium-button',
};
